<div class="c-wrapper">
    <div class="c-n-wrapper" id="cDesc">
        <span multilang class="c-title">{{datas?.CustomOffer?.Accommodation?.AccommodationName}}</span>
    </div>
    <ng-container *ngIf="datas?.extracomment?.length > 0">
        <div class="c-block">
            <div class="c-item">
                <span multilang class="c-item-title">Extra info</span>
                <div class="v-wrapper">
                    <pre class="ml pree">{{datas?.extracomment}}</pre>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="c-block">
        <ng-container *ngFor="let cont of datas?.CustomOffer?.Accommodation?.ContentTexts?.ContentText">
            <div class="c-item">
                <span multilang *ngIf="cont.$?.Header?.length > 0" class="c-item-title">{{cont.$?.Header |
                    cleanText}}</span>
                <div multilang deeplMode='html' [innerHtml]="cont._ | cleanText | safehtml" class="c-content">
                </div>
            </div>
        </ng-container>
    </div>

    <div class="f-btn-wrapper">
        <button class="f-btn" matRipple (click)="sendAnmeldung()">Buchen</button>
    </div>
</div>

<div class="fixedlefttop">
    <button class="f-b-top" matRipple (click)="sendAnmeldung()">Buchen</button>
</div>